import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import CampaignPhone from '../Overview/campaignPhone';
import { formatCurrency } from '../../../helpers/helperFunction';
import config from '../../../config/Constant';
import CustomAlert from '../../../components/CustomAlert';

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const CreateCampaignSidebar = ({ campaign_form_fields }) => {
  const { message_content, message_count, campaign_price, sms_count, brand_name, user_rates } = campaign_form_fields;
  const { country, currency, available_balance } = useSelector((state) => state.auth.user);
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const unique_user_rates = user_rates.filter((rate, index, self) =>
    index === self.findIndex((t) => (
      t.country === rate.country && t.user_rate === rate.user_rate
    ))
  );

  const newmessage_content = country === 'MY'
    ? `RM0 ${brand_name}: ${message_content}`
    : message_content;

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <div className="Sidebar" style={{ padding: "0 30px" }}>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <div className="text-center">
        <CampaignPhone message={newmessage_content} />
      </div>
      <div className="title-heading"><h3>Campaign Summary</h3></div>
      <div className="pricing-wrapper">
        <div className="pricing-item">
          <div className="left">No. of Contacts</div>
          <div className="right">{sms_count}</div>
        </div>
        <div className="pricing-item">
          <div className="left">Message Count</div>
          <div className="right">{message_count}</div>
        </div>
        {!white_label_perkeso && (
          <>
            {unique_user_rates.map((result, index) => (
              <div key={index} className="pricing-item">
                <div className="left">SMS Rate {result.country}</div>
                <div className="right">{result.user_rate.toFixed(2)}</div>
              </div>
            ))}
            <div className="pricing-item">
              <div className="left">Campaign Cost</div>
              <div className="right">{formatCurrency(currency?.iso3, campaign_price)}</div>
            </div>
          </>
        )}
      </div>
      <div className="notification-info">
        <strong>Campaign</strong> will be sent{' '}
        <strong>
        </strong>{' '}
        to <strong>{sms_count} Contacts</strong>
        {!white_label_perkeso && (
          <>
            {' '}and{' '}
            <strong style={{ color: campaign_price > available_balance ? '#F76659' : '#000000' }}>
              {formatCurrency(currency?.iso3, campaign_price)}
            </strong>{' '}
            will be spent
          </>
        )}
      </div>
    </div>
  );
};

export default CreateCampaignSidebar;